<!-- Copyright (C) GridGain Systems. All Rights Reserved.
   _________        _____ __________________        _____
   __  ____/___________(_)______  /__  ____/______ ____(_)_______
   _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
   / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
   \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/ -->

<status-output
  [value]="status()"
  [matTooltip]="getClusterStatusTooltip(status()) ?? ''"
  [matTooltipDisabled]="!onlyIcon()"
>
  @for (item of statuses; track identity(item)) {
    <!-- prettier-ignore -->
    <status-output-param [value]="item.status" [level]="item.level" [icon]="item.icon" [svgIcon]="item.svgIcon"
    >@if (!onlyIcon()) {{{ getClusterStatusText(item.status) }}}</status-output-param>
  }
</status-output>
